import {MiniCartController} from '@wc-stripe/controllers';
import {getSetting} from '@wc-stripe/utils';
import Context from '@wc-stripe/context';
import {GooglePayGateway} from '@wc-stripe/gateways'

const settings = getSetting('stripe_googlepay_data');

const context = new Context('minicart');

const gateway = new GooglePayGateway({
    id: 'stripe_googlepay',
    settings,
    context
});

const controller = new MiniCartController({
    context,
    gateway,
    selector: 'a.wc-stripe_googlepay-mini-cart'
});

controller.initialize();